export enum TimeStatus {
    Disapproved = 'Disapproved',
    Booked = 'Booked',
    Approved = 'Approved'
}
